function getAccessToken () {
  // eslint-disable-next-line no-undef
  const token = window.storefrontAccessToken?.[Shopify.shop || Shopify.Checkout?.apiHost || location.hostname]
  return token || window.storefrontAccessToken[window.DEV_HOSTNAME]
}

export const storefrontRequestConfig = {
  headers: {
    'Content-Type': 'application/graphql',
    'X-Shopify-Storefront-Access-Token': getAccessToken()
  }
}

// XHR request header is required to catch certain errors e.g. adding over quantity available
// https://community.shopify.com/c/Shopify-Design/AJAX-POST-cart-add-js-NEVER-returns-422-only-200-OK-on/m-p/375736
// https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header
export const xhrRequestConfig = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
}

export function getStorefrontApiUrl () {
  // eslint-disable-next-line no-undef
  switch (Shopify.shop || Shopify.Checkout?.apiHost || location.hostname) {
    case window.PROD_HOSTNAME:
      return window.storefrontApiUrl.prod
    case window.UAT_HOSTNAME:
      return window.storefrontApiUrl.uat
    default:
      return window.storefrontApiUrl.dev
  }
}
